<script setup lang="ts">
import { AlertTriangle } from 'lucide-vue-next'
</script>

<template>
  <div class="flex min-h-screen items-center justify-center bg-background px-4">
    <div class="max-w-sm space-y-4 text-center">
      <AlertTriangle class="mx-auto size-12 text-amber-500" />
      <h1 class="text-xl font-bold">Link expired or invalid</h1>
      <p class="text-sm text-muted-foreground">
        This upload link has expired or is invalid. Please contact TLC to receive a new link.
      </p>
      <p class="text-sm font-medium">Call us on 1300 045 047</p>
    </div>
  </div>
</template>
